import { createActions } from 'reduxsauce';

export const { Creators, Types } = createActions({
  getEquipmentsList: ['payload'],
  getEquipmentsListStart: ['payload'],
  getEquipmentsListSuccess: ['payload'],
  getEquipmentsListFailure: ['payload'],

  setSearchQueries: ['payload']
});
